import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { Field, reduxForm } from "redux-form";
import { Form } from 'react-bootstrap';
import { FormattedMessage } from "react-intl";
import messages from "../../locale/messages";
import { api, profilePhotouploadDir } from "../../config";
import StarRating from "../StarRating/StarRating";
import defaultIcon from '/public/dashboard/defaultIconMenu.svg';
import bt from '../../components/commonStyle.css';
import s from './ProviderReviewCard.css';

const renderStarRating = ({ input }) => {
    return (
        <span>
            <StarRating
                name={input.name}
                change={input.onChange}
                editing={true}
                starCount={5}
                className={s.paymentReviewStarContainer}
                editReviewStarSize={30}
            />
        </span>
    );
}

function ProviderReviewCard({ data }) {
    const providerImage = data?.partnerDetails?.picture ? `${api.apiEndpoint}${profilePhotouploadDir}${data?.partnerDetails?.picture}` : defaultIcon

    return (
        <div className={s.paymentReviewCard}>
            <div className={s.paymentReviewCardImgContainer}>
                <img src={providerImage} alt="profileImg" />
            </div>
            <div className={s.paymentReviewCardInfo}>
                <h5 className={cx(s.paymentReviewCardInfoHeading, bt.space3, bt.primaryColor)}>{data?.partnerDetails?.firstName}</h5>
                <Form className={bt.space2}>
                    <Field
                        name="rating"
                        component={renderStarRating}
                    />
                </Form>
                <div className={cx(bt.commonSize14, bt.fontWeight400, bt.secondaryColor)}>
                    <FormattedMessage {...messages.rateYourExperience} />
                </div>
            </div>
        </div>
    )
}
ProviderReviewCard = reduxForm({
    form: 'ProviderReviewCard'
})(ProviderReviewCard);

export default withStyles(bt, s)(ProviderReviewCard);

